import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
import { toast } from "react-toastify";
import { Box, Button, Checkbox, Modal, Stack, Typography } from "@mui/material";
import { Add as AddIcon, ImportExport } from "@mui/icons-material";
import { RoleContext } from "../RoleContext";
import Table from "../Theme/Table";
import AddSubscriber from "./AddSubscriber";
import DeleteConfirmation from "../deleteConfirmation";
import EditSubscriber from "./EditSubscriber";
import { exportExcelSubscriberList } from "../reports/SubscriberLists";
import { Badge } from "antd";
import { Link } from "react-router-dom";

function SubscriberList({ name }) {
  const edit = "subscriber";
  const detail = "viewSubscriber";

  let [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const location = useLocation();
  const [subscribers, setSubscribers] = useState([]);
  const [id, setId] = useState(null);

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);

  const params = useParams();
  const ids = params.id;
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);

  const [displayAddCreditModal, setDisplayAddCreditModal] = useState(false);
  const showAddCreditModal = (id) => {
    let roleId = JSON.parse(localStorage.getItem("userData")).roleId;
    if (roleId === 30 || roleId === 31) {
      setId(roleId);
    } else {
      setId(id);
    }

    axios.get("/driver/" + id, {}).then((res) => {
      setData(res.data.driver);
      setDisplayAddCreditModal(true);
    });
  };

  const [displayEditModal, setDisplayEditModal] = useState(false);
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this subscriber`);
    setDisplayConfirmationModal(true);
  };
  const showEditModal = (id) => {
    setId(id);

    axios.get("/company/subscriber/" + id, {}).then((res) => {
      setData(res.data);
      console.log("=======subs data===", res.data);
      setDisplayEditModal(true);
    });
  };
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };

  const submitDelete = (id) => {
    console.log(id);
    deleteSubscriber(id);
    setDisplayConfirmationModal(false);
  };
  const deleteSubscriber = async (id) => {
    const response = await axios.delete("/company/subscriber/" + id, {
      data: { id: id },
    });
    getSubscribers();
  };

  const notify = () =>
    toast.success("Subscriber list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getSubscribers();
  }, [location.key]);

  const getSubscribers = async () => {
    try {
      const response = await axios
        .get("/company/subscribers/" + ids)
        .then((res) => {
          setSubscribers(res.data);
          setLoading(false);
          notify();
        })
        .catch((err) => {
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "firstName",
          },
          {
            Header: "Last Name",
            accessor: "lastName",
          },
          {
            Header: "Gender",
            accessor: "gender",
          },
        ],
      },
      {
        Header: "Info",
        columns: [
          {
            Header: "Phone Number",
            accessor: "phoneNumber",
          },
          {
            Header: "Address",
            accessor: "address",
          },
          {
            Header: "Rating",
            accessor: "rating",
          },
          {
            Header: "Useage Limit",
            accessor: "usageLimit",
          },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                <Badge badgeContent={"Active"} color="success">
                  {" "}
                </Badge>
              </div>
            ),
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter(function (e) {
                  return e.perm_name === "edit_passenger";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showEditModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-edit info" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "delete_passenger";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showDeleteModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-trash error" />
                  </Link>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Rating",
        accessor: "rating",
      },
      {
        Header: "Useage Limit",
        accessor: "usageLimit",
      },
    ],
    []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClickDriver(
      subscribers,
      columns_expo,
      selectedColumns,
      "Subscribers",
      "subscriber_list.pdf"
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const reportStyles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      marginTop: "50px",
    },
    button: {
      // backgroundColor: "green",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
    },
    buttonTwo: {
      border: "none",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
      fontSize: "20px",
    },
    contain: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#198754",
      // margin: "10px",
      // padding: "20px 20px",
      // width: "270px",
      fontSize: "22px",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    icon: {
      fontWeight: "bold",
      fontSize: "20px",
      color: "white",
      marginLeft: "7px",
      marginRight: "3px",
    },
  };

  const printableRef = useRef(null);

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };

  const [formats, setFormats] = useState("PDF");
  const items = [
    {
      label: <p style={reportStyles.buttonTwo}>In EXCEL format</p>,
      key: "EXCEL",
    },
  ];

  const handleDropdownChange = (selectedFormat) => {
    if (selectedFormat === "EXCEL") {
      exportExcelSubscriberList(name, subscribers);
    } else {
      setFormats("PDF");
    }
  };

  return (
    <div>
      <AddSubscriber
        getSubscribers={getSubscribers}
        displayAddModal={displayAddModal}
        setDisplayAddModal={setDisplayAddModal}
        showModal={displayAddModal}
        hideModal={hideAddModal}
      />
      <div className="col-13" ref={printableRef}>
        <div className="card">
          {/* <div className="card-header"> */}
            {/* <h3 className="card-title">Subscriber List</h3> */}
            <Box sx={{ p: 2, pt: 2, backgroundColor: "background.paper", borderRadius: 2, boxShadow: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h5" sx={{ fontWeight: 600, color: "text.primary", display: "flex", alignItems: "center", gap: 1 }}>
          <Box component="span" sx={{ width: 4, height: 24, backgroundColor: "primary.main", borderRadius: "2px", display: "block" }} />
          Subscriber List
        </Typography>
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={showAddModal}>
            Add Subscriber
          </Button>
          <Button variant="outlined" color="secondary" startIcon={<ImportExport />} onClick={() => exportExcelSubscriberList(name, subscribers)}>
            Export
          </Button>
        </Stack>
      </Box>
            <Modal
            style={{marginTop: "60px"}}
              title="Select Columns to Export"
              visible={isModalVisible}
              onOk={handleOkModal}
              onCancel={handleCancel}
              footer={[
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button
                  style={{ marginLeft: "10px" }}
                  key="ok"
                  type="primary"
                  onClick={handleOkModal}
                >
                  OK
                </Button>,
              ]}
            >
              <div style={{ marginBottom: "20px" }}>
                {columns_expo.map((column) => (
                  <div key={column.Header} style={{ marginBottom: "10px" }}>
                    <Checkbox
                      checked={selectedColumns.includes(column.Header)}
                      onChange={() => handleColumnToggle(column.Header)}
                      style={{ marginRight: "10px", fontSize: "16px" }}
                    >
                      {column.Header}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </Modal>
          {/* </div> */}

          <div className="card-body">
            <Table
              columns={columns}
              data={subscribers}
              edit={edit}
              detail={detail}
            />
          </div>
        </div>

        {displayEditModal == true && (
          <EditSubscriber
            id={id}
            data={data}
            showModal={displayEditModal}
            hideModal={hideEditModal}
            getSubscribers={getSubscribers}
          />
        )}
      </div>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
    </div>
  );
}

export default SubscriberList;
